export const requestTrackingPermissionsAsync = () => Promise.resolve()
